import GoogleStaffSignIn from '../components/auth/GoogleStaffSignIn';
import ClinixLogo from '../components/brand/ClinixLogo';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { SessionUser } from '../utils/session';

const containerStyle: React.CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  padding: '20px',
  position: 'relative',
  overflow: 'hidden'
};

const backgroundShapeStyle: React.CSSProperties = {
  position: 'absolute',
  borderRadius: '50%',
  background: 'rgba(102, 126, 234, 0.1)',
  filter: 'blur(80px)'
};

const cardStyle: React.CSSProperties = {
  background: 'rgba(30, 41, 59, 0.95)',
  padding: '3rem 2.5rem',
  borderRadius: '24px',
  boxShadow: '0 20px 60px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1)',
  width: '100%',
  maxWidth: '440px',
  position: 'relative',
  backdropFilter: 'blur(10px)',
  border: '1px solid rgba(255, 255, 255, 0.1)'
};

const logoContainerStyle: React.CSSProperties = {
  textAlign: 'center',
  marginBottom: '2rem'
};

const logoStyle: React.CSSProperties = {
  fontSize: '4rem',
  marginBottom: '0.5rem',
  display: 'inline-block',
  animation: 'float 3s ease-in-out infinite'
};

const titleStyle: React.CSSProperties = {
  textAlign: 'center',
  color: '#f1f5f9',
  fontSize: '2rem',
  fontWeight: '700',
  marginBottom: '0.5rem',
  letterSpacing: '-0.02em'
};

const subtitleStyle: React.CSSProperties = {
  textAlign: 'center',
  color: '#94a3b8',
  fontSize: '0.95rem',
  marginBottom: '2rem',
  fontWeight: '400'
};

const footerStyle: React.CSSProperties = {
  textAlign: 'center',
  marginTop: '2rem',
  fontSize: '0.8rem',
  color: '#94a3b8',
  paddingTop: '1.5rem',
  borderTop: '1px solid #e2e8f0'
};

export default function Login({ onLogin }: { onLogin: (token: string, user?: SessionUser) => void }) {
  const { t } = useTranslation();

  return (
    <div className="responsive-row" style={containerStyle}>
      {/* Background decoration shapes */}
      <div style={{ ...backgroundShapeStyle, width: '400px', height: '400px', top: '-200px', left: '-100px' }} />
      <div style={{ ...backgroundShapeStyle, width: '300px', height: '300px', bottom: '-150px', right: '-50px' }} />

      <style>
        {`
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
          }
        `}
      </style>

      <div className="login-card" style={cardStyle}>
        <div style={logoContainerStyle}>
          <div style={logoStyle}><ClinixLogo size={88} style={{ filter: 'drop-shadow(0 10px 24px rgba(14, 165, 233, 0.35))' }} /></div>
          <h2 style={titleStyle}>Clinix</h2>
          <p style={subtitleStyle}>{t('login.title')}</p>
        </div>

        <GoogleStaffSignIn onLogin={onLogin} />

        <div style={footerStyle}>
          <div>{t('login.footer')}</div>
        </div>
      </div>
    </div>
  );
}
